import { Flex, useMantineTheme } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { JSX, ReactNode } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Targeting } from '@feathr/blackbox';
import { Text, Well } from '@feathr/components';
import { Glue } from '@feathr/extender/components';

import * as styles from './SelectedTargetings.css';

interface IProps {
  targetings: Targeting[];
  label: string;
  children: ReactNode;
  glue?: boolean;
  description?: string;
}

function TargetingsWell({
  targetings,
  label,
  children,
  glue = false,
  description,
}: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  const wellDescription = description ? description : t('any of the selected');
  const hasMultipleTargetings = targetings.length > 1;

  const wellLabel = (
    <>
      {label}{' '}
      {hasMultipleTargetings && (
        <Text.DefaultRegular mantineComponent={'span'}>({wellDescription})</Text.DefaultRegular>
      )}
    </>
  );

  return (
    <>
      <Well className={styles.well} label={wellLabel} layout={'vertical'}>
        {targetings.length > 0 ? (
          <Flex gap={theme.spacing['2']} wrap={'wrap'}>
            {children}
          </Flex>
        ) : (
          <Text.DefaultRegular>{t('None selected')}</Text.DefaultRegular>
        )}
      </Well>
      {glue && <Glue suppressGap={true} t={t} />}
    </>
  );
}

export default observer(TargetingsWell);
